import React from "react";
import { IoWarningOutline } from "react-icons/io5";
import styles from "./WarningIcon.module.css";

export const WarningIcon = () => {
  return <IoWarningOutline className={styles.warning_icon} />;
};
